
import React from 'react';
import { connect } from 'react-redux';

import { marketSettings } from '../../../../selectors/marketSettings';

import MarketSettings from '..';
import { PERMISSIONS } from '../../../../constants';
import { aGetMarketSettingsRequest, aUpdateOddsDisabledStatus, aUpdateResultsDisabledStatus } from '../../../../reducers';
import { aClearMarketSettings } from '../../../../reducers/marketSettings';

const mapToProps = (state) => ({
  marketSettings: marketSettings(state),
});

const actionsToProps = (dispatch) => ({
  getMarketSettings: (payload) => dispatch(aGetMarketSettingsRequest(payload)),
  updateOddsDisable: (payload) => dispatch(aUpdateOddsDisabledStatus(payload)),
  updateResultsDisable: (payload) => dispatch(aUpdateResultsDisabledStatus(payload)),
  clearMarketSettings: (payload) => dispatch(aClearMarketSettings(payload)),
});

const SoccerMarketSettings = (props) => (
  <MarketSettings
    getMarketSettings={props.getMarketSettings}
    updateOddsDisable={props.updateOddsDisable}
    updateResultsDisable={props.updateResultsDisable}
    clearMarketSettings={props.clearMarketSettings}
    marketSettings={props.marketSettings}
    oddsDisableEnableMarketPermission={PERMISSIONS.MARKETSETTINGS_MAINMARKETS_ODDS_DISABLE_ENABLE}
    resultsDisableEnableMarketPermission={
      PERMISSIONS.MARKETSETTINGS_MAINMARKETS_RESULTS_DISABLE_ENABLE
    }
  />
);

export default connect(mapToProps, actionsToProps)(SoccerMarketSettings);
